// extracted by mini-css-extract-plugin
export default {"root":"SuspensePagination_root__aPSgC"};